import React, { useState } from 'react';
import HighchartsReact from 'highcharts-react-official';
import HighchartsGantt from "highcharts/highcharts-gantt";
import Exporting from 'highcharts/modules/exporting';
import OfflineExporting from 'highcharts/modules/offline-exporting';

Exporting(HighchartsGantt);
OfflineExporting(HighchartsGantt);

const RegulatoryTimelinesChart = () => {

	const [graphOptions, setGraphOptions] = useState(window.regulatoryTimelinesChartGraphOptions);

	return (

		<HighchartsReact highcharts={HighchartsGantt} constructorType="ganttChart" options={graphOptions} />
	
	);

}

export default RegulatoryTimelinesChart;